export var NavItemDefaultProps = {
    as: 'a',
    children: '',
    className: undefined
};
